module.exports = __webpack_public_path__ + "static/media/gelan_plus.7a840eb6.png";